import '../../css/partnership.css';
import axios from 'axios';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import State from '../data/State';
import BackButton from '../components/BackButton';
import HeaderLogo from '../components/HeaderLogo';
import User from '../data/User';
import { screen } from '../types/enums';
import CustomSelect from '../components/CustomSelect';

enum typeModal {
  SIZE,
  TYPE,
  DONE
}

export default observer(() => {
    const optionstypeShop = [
    { value: 'bar', label: 'Бар' },
    { value: 'restoran', label: 'Ресторан' },
    { value: 'kafe', label: 'Кафе' },
    { value: 'kofeynya', label: 'Кофейня' },
    { value: 'launzh', label: 'Лаунж / кальянная' },
    { value: 'klub', label: 'Клуб / мероприятие' },
    { value: 'other', label: 'Другое (ввести вручную)' }
  ];

  const optionsformat = [
    { value: 'postavka', label: 'Поставка продукции' },
    { value: 'promo', label: 'Промо и маркетинговая поддержка' },
    { value: 'merch', label: 'Мерч / оформление от бренда' },
    { value: 'meropriyatie', label: 'Проведение совместных мероприятий' },
    { value: 'partnerstvo', label: 'Временное партнёрство (ивенты, фестивали)' },
    { value: 'other', label: 'Другое (ввести вручную)' }
  ];

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<typeModal>(null);

  const [typeShopValueSelect, setTypeShopValueSelect] = useState('');
  const [typeShopValueOther, setTypeShopValueOther] = useState('');
  const typeShop = typeShopValueSelect === 'other'
    ? typeShopValueOther
    : optionstypeShop.find(opt => opt.value === typeShopValueSelect)?.label || '';

  const [shop, setShop] = useState('');
  const [city, setCity] = useState('');
  const [adress, setAdress] = useState('');
  const [fio, setFio] = useState('');
  const [position, setPosition] = useState('');
  const [phone, setPhone] = useState('+7');
  const [mail, setMail] = useState('');
  const [license, setLicense] = useState('Нет');

  const [formatValueSelect, setFormatValueSelect] = useState('');
  const [formatValueOther, setFormatValueOther] = useState('');
  const format = formatValueSelect === 'other'
    ? formatValueOther
    : optionsformat.find(opt => opt.value === formatValueSelect)?.label || '';

  const [interest, setInterest] = useState('');
  const [about, setAbout] = useState('');
  
  const [agreement, setAgreement] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [mailError, setMailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegExp = /^\+7\d{10}$/;

  const prepareData = () => {
    if (waiting) return;
    const testMail = emailRegExp.test(mail);
    const testPhone = phoneRegExp.test(phone);
    !testMail && setMailError(true);
    !testPhone && setPhoneError(true);

    if (testMail && testPhone) {
      setWaiting(true);
      const data = {
        typeShop:typeShop,
        shop: shop,
        city: city,
        adress:adress,
        fio: fio,
        position: position,
        phone: phone,
        mail: mail,
        license: license,
        format: format,
        interest: interest,
        about: about,
      }
      sendData(data);
    }
  }

  const sendData = (data: {[key: string]: string }) => {
    axios.post(process.env.REACT_APP_API + '/sendPartnership', {
      init_data: User.getInitData(),
      id: User.getID(),
      data: data
    }).then(res => {
      if (!res.data.error) {
        setModalType(typeModal.DONE);
        setShowModal(true);
      } else {
        State.setScreen(screen.ERROR);
      }
    }).catch(e => State.setScreen(screen.ERROR));
  }

  const modal = () => {
    return (
      <div className='partnership-modal-block'>
        <div className='partnership-modal'>
          <div className='partnership-modal-text'>Ваша заявка принята!</div>
          <div className='partnership-modal-buttons'>
            <div onClick={() => {
              State.setScreen(screen.MAIN);         
            }}>На главную</div>
          </div>
        </div>
      </div>
    );
  }

  const setFormatPhone = (phone: string) => {
    if (phone.length < 3) {

      if (phone !== '+7' && phone !== '+' && phone !== '') {
        phone = '+7';
      }
    } else {

      if (phone[0] !== '+') {
        phone = '+' + phone;
      }

      if (phone[1] !== '7') {
        phone = phone[0] + '7' + phone.slice(2);
      }
      phone = '+7' + phone.slice(2).replace(/[^0-9]/g, '');

      if (phone.length > 12) {
        phone = phone.slice(0, 12);
      }
    }
    setPhone(phone);
  }

  const sendActive = Boolean(typeShop && shop && city && adress && fio && position && phone && mail && license && format && interest && about && agreement) || waiting;
  const buttonName = waiting ? 'Подождите' : 'Отправить заявку';

  return (
    <div className='partnership-block'>
      <BackButton callback={() => State.toBackScreen()} />
      <HeaderLogo />
      <div className='partnership-partner-block'>
        <div className='partnership-partner-title'>Станьте<br /> партнером</div>
        <div className='partnership-partner-santo'>Santo stefano</div>
      </div>
      <div className='partnership-data-block'>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Тип заведения</div>
          <CustomSelect
            options={optionstypeShop}
            value={typeShopValueSelect}
            onChange={setTypeShopValueSelect}
            placeholder="Выберите тип"
          />
          {typeShopValueSelect === 'other' && (
            <input
              className='partnership-input'
              type="text"
              value={typeShopValueOther}
              onChange={e => setTypeShopValueOther(e.target.value)}
              placeholder="Введите свой вариант"
            />
          )}
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Название заведения</div>
          <input className='partnership-input' value={ shop } onChange={e => setShop(e.target.value)} placeholder='Магнит' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Город</div>
          <input className='partnership-input' value={ city } onChange={e => setCity(e.target.value)} placeholder='Москва' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Адрес</div>
          <input className='partnership-input' value={ adress } onChange={e => setAdress(e.target.value)} placeholder='ул. Ленина, д. 15 ' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Контактное лицо</div>
          <input className='partnership-input' value={ fio } onChange={e => setFio(e.target.value)} placeholder='ФИО' type='text' />
          <input className='partnership-input' value={ position } onChange={e => setPosition(e.target.value)} placeholder='Должность' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Контактный телефон</div>
          <input className={'partnership-input' + (phoneError ? ' partnership-error' : '')} value={ phone } onChange={e => {
            setPhoneError(false);
            setFormatPhone(e.target.value);
          }} placeholder='+79000000000' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Email</div>
          <input className={'partnership-input' + (mailError ? ' partnership-error' : '')} value={ mail } onChange={e => {
            setMailError(false);
            setMail(e.target.value);
          }} placeholder='example@mail.ru' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>У вас уже есть лицензия на продажу алкоголя?</div>
          <div className='partnership-radio-block'>
            <label className="partnership-radio-item"><input className="partnership-radio" type="radio" value="Да" name="license" checked={license === 'Да'} onChange={e => setLicense(e.target.value)} /> Да</label>
            <label className="partnership-radio-item"><input className="partnership-radio" type="radio" value="Нет" name="license" checked={license === 'Нет'} onChange={e => setLicense(e.target.value)}/> Нет</label>
          </div>
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Интересующий формат сотрудничества</div>
          <CustomSelect
            options={optionsformat}
            value={formatValueSelect}
            onChange={setFormatValueSelect}
            placeholder="Выберите формат"
          />
          {formatValueSelect === 'other' && (
            <input
              className='partnership-input'
              type="text"
              value={formatValueOther}
              onChange={e => setFormatValueOther(e.target.value)}
              placeholder="Введите свой вариант"
            />
          )}
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Какие продукты вам интересны?</div>
          <input className='partnership-input' value={ interest } onChange={e => setInterest(e.target.value)} placeholder='Игристое вино' type='text' />
        </div>
        <div className='partnership-input-block'>
          <div className='partnership-input-label'>Комментарий / предложения</div>
          <textarea
            placeholder='Комментарий / предложения'
            className='partnership-textarea'
            onChange={e => setAbout(e.target.value)}
            defaultValue={ about }
          ></textarea>
        </div>
        <div className='partnership-checkbox-block'>
          <div className={'partnership-checkbox reg-checkbox-' + (agreement ? 'enable' : 'disable')} onClick={() => setAgreement(!agreement)}></div>
          <a href={ State.AGREEMENT } target='_blank'>Пользовательское соглашение</a>
        </div>
        <div className='partnership-button-block'>
          <div className='gold-button' style={{ opacity: sendActive ? 1 : .5 }} onClick={() => {
            if (!sendActive) return;
            prepareData();
          }}>{ buttonName }</div>
        </div>
      </div>
      { showModal && modal() }
    </div>
  );
});